import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import AIChat from "./AIChat";

export default function Layout({ children }) {
    return (
        <div className="min-h-screen flex flex-col bg-white">
            <Navbar />
            <main className="flex-1 pt-[68px]">{children}</main>
            <Footer />
            <AIChat />
        </div>
    );
}
